import { ServerConfig } from '../type';

export const DEFAULT_SERVER_CONFIG: ServerConfig = {
  domain: 'localhost',
  port: 4000,
  protocol: 'http',
};
